export function hasFiltersApplied (filters) {
  for (const property in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, property)) {
      if (filters[property] != "ALL" && filters[property] != null) return true
    }
  }
  return false
}
